exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#map[data-v-2ecebcce] {\n    width: 100%;\n    height: 500px;\n}\n", ""]);

// exports
